module.exports = __webpack_public_path__ + "static/img/Q.b08b67f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mssj/Q.png
// module id = Ge0v
// module chunks = 0